// 此文件用来保存所有后端返回的状态码，但是并不是要把后端所有定义的code码写在这里，只需要填写用到的
// 工作室后端返回的状态码
export enum CodeStudio {
  StudioNotExist = 101204, // 不存在此工作室
  StudioApplyTimeScopeFail = 101205, // 邀请同一个人在24小时内，不允许多次申请
  UserRoleRemoveSelfFail = 101215, // owner不可移除当前用户自己
  MemberInviteUserExistStudioFail = 101218, // 此成员已经存在工作室中
  MemberJoinStudioExistApproval = 101226, // 用户主动加入工作室，已经在审批流程中
  OnlyJoinOneStudio = 101229, // 只能申请加入一个工作室
  MemberHasJoinOtherStudio = 101232, // 此用户已经加入其他工作室，可能是其他工作室主动邀请的。而非用户主动申请
  CreateStudioMaxLimit = 101234, // 每个人最多创建N个工作室
}
// 用户信息
export enum CodeUser {
  OldPasswordError = 111011, // 旧密码错误
}

// 消息中心
export enum CodeMessageCenter {
  CreateFail = 101601, // 创建消息失败
}
// 服务申请
export enum CodeServices {
  CompanyAuthNotComplete = 101848, // 未完成企业认证
  UserApplyOpenedServiceNotFound = 101811, // 用户申请开通的服务不存在
  CurrentServiceApproval = 101813, // 当前服务已经在审批中，请勿重新申请
  NotExistToApprovalURL = 101812, // 参数不全，缺少审批页面url
}

// 所有后端返回的code码
export const BackEndCode = {
  ...CodeStudio,
  ...CodeUser,
  ...CodeMessageCenter,
  ...CodeServices,
};
